import { View } from "extensions/marionette";

import {
    NotImplementedError
} from "common/helpers/errors";

import { SummaryBar } from "./summaryBar";
import template from "./tabBody.jst";

export const TabBodyView = View.extend({
    template,
    regions: {
        summary: ".summary",
        content: ".tab-main-content"
    },
    makeSummary() {
        return new SummaryBar({
            model: this.model,
            totals: this.getOption("widget").model.subtypeModel.get("doublePivot").summary.totals({
                collection: this.collection,
                model: this.model,
                pivot: this.getOption("primaryPivot"),
                ref: this.getOption("primaryPivotRef")
            })
        });
    },
    makeContentBody() {
        throw new NotImplementedError();
    },
    
    // Not sure why `onAttach` works here, but `onRender` does NOT
    // Need to investigate more the entire flow. For some strange reason, Marionette will not render content
    // Of the first tab if using `onRender`
    onAttach() {
        if (this.getOption("widget").model.isSummaryEnabled()) {
            this.showChildView("summary", this.makeSummary());
        }
        
        this.showChildView("content", this.makeContentBody());
    }
});
